import { render, staticRenderFns } from "./courseAudit.vue?vue&type=template&id=e50bbd8e&"
import script from "./courseAudit.vue?vue&type=script&lang=js&"
export * from "./courseAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports